export default __webpack_public_path__ + "static/204-bb1f3e6b07fcb3ccd518cd2905909f38.gif";